import moment from "moment";
import SuccessModal from "../../../myfin_v2/components/connections/SuccessModal";
import ErrorModal from "../../../myfin_v2/components/connections/ErrorModal";

import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import { Button } from "../../../myfin_v2/elements/Button";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import standaloneCss from "../../../myfin_v2/css/standalone.module.css";

import { useState, useEffect } from "react";
import ConsolDropdown from "../../../myfin_v2/elements/ConsolDropdown";
import ChipsGroup from "../../../myfin_v2/elements/ChipsGroup";
import { getManualRelatedPartyDetailsApiHandler, setManualRelatedPartyDetailsApiHandler } from "../ApiServices/apiHandler";

const AddRPTTransactionModal = ({ setShowAddRPTTransactionModal, onSuccess }) => {
  const project_id = localStorage.getItem("project_id");

  const [relatedParties, setRelatedParties] = useState([]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [allOutsatandingBalance, setAllOutsatandingBalance] = useState([]);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [selectedOutstandingBalance, setSelectedOutstandingBalance] = useState(
    [],
  );
  const [selRelatedParty, setSelRelatedParty] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    getManualRelatedPartyDetails();
  }, []);

  useEffect(() => {
    let timer;
    if (showSuccessModal) {
      timer = setTimeout(async () => {
        setShowSuccessModal(false);
        setShowAddRPTTransactionModal(false);
        if (typeof onSuccess === "function") {
          try {
            await onSuccess();
          } catch (err) {
            console.error("Failed to auto-refresh RPT tables", err);
          }
        }
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [showSuccessModal, onSuccess, setShowAddRPTTransactionModal]);

  useEffect(() => {
    let timer;
    if (showErrorModal) {
      timer = setTimeout(() => {
        setShowErrorModal(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [showErrorModal]);

  const getManualRelatedPartyDetails = () => {
    const getParams = {
      projectID: project_id,
    };
    getManualRelatedPartyDetailsApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          setRelatedParties(response?.data?.relatedPartyNameList ?? []);
          setAllTransactions(response?.data?.transactionList ?? []);
          setAllOutsatandingBalance(
            response?.data?.outstandingBalanceList ?? [],
          );
        } else {
          setErrorMessage(
            response?.data?.error ||
              "Unable to get manual related party details",
          );
          setShowErrorModal(true);
        }
      })
      .catch((error) => {
        setErrorMessage(
          error?.response?.data?.error ||
            "Unable to populate manual related party details",
        );
        setShowErrorModal(true);
      });
  };

  const handleSave = () => {
    const payload = {
      relatedPartyName: selRelatedParty,
      transaction: selectedTransactions,
      outstandingBalance: selectedOutstandingBalance,
    };

    setManualRelatedPartyDetailsApiHandler({ projectID: project_id }, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          setSuccessMessage("Related Party added successfully");
          setShowSuccessModal(true);
        } else {
          setErrorMessage(
            response?.data?.error || "Unable to add Related Party",
          );
          setShowErrorModal(true);
        }
      })
      .catch((error) => {
        setErrorMessage(
          error?.response?.data?.error || "Unable to add Related Party",
        );
        setShowErrorModal(true);
      });

  };

  return (
    <>
      <Modal
        title={"Add Related Party"}
        width="35%"
        minHeight="350px"
        headerActions={
          <CloseIcon
            onClick={() => {
              setShowAddRPTTransactionModal(false);
            }}
            className="clickable"
          />
        }
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                setShowAddRPTTransactionModal(false);
              }}
              label="Cancel"
            />
            <Button
              btnColor={buttoncss.primary}
              label="Proceed"
              onClick={() => {
                handleSave();
              }}
            />
          </>
        }
        onClose={() => console.log("Modal Closed")}
      >
        <div style={{ width: "95%", placeSelf: "center", display: "flex", flexDirection: "column", gap: "10px" }}>
          <InputGroup
            label="Related Party Name"
            labelStyle={{ fontSize: "15px", fontWeight: 500 }}
            inputs={[
              <ConsolDropdown
                isEditable={true}
                options={relatedParties.map((item) => ({
                  label: item,
                  value: item,
                }))}
                onSelect={(sel) => {
                  setSelRelatedParty(sel ? sel.value : null);
                }}
                placeHolder="Select Related Party Name"
                selected={{ label: selRelatedParty || "", value: selRelatedParty || "" }}
              />,
            ]}
          />

          {/* TRANSACTIONS */}
          <ChipsGroup
            title="Transaction"
            items={allTransactions}
            selectedItems={selectedTransactions}
            onChange={setSelectedTransactions}
            allowCustomInput={true}
            customInputLabel="Other Transactions"
            customInputPlaceholder="Enter Other Transactions"
          />

          {/* OUTSTANDING BALANCE */}
          <ChipsGroup
            title="Outstanding Balance"
            items={allOutsatandingBalance}
            selectedItems={selectedOutstandingBalance}
            onChange={setSelectedOutstandingBalance}
            allowCustomInput={true}
            customInputLabel="Other Outstanding Balance"
            customInputPlaceholder="Enter Other Outstanding Balance"
          />
        </div>
      </Modal>

      {showSuccessModal && (
        <SuccessModal
          handleClose={async () => {
            setShowSuccessModal(false);
            setShowAddRPTTransactionModal(false);
            if (typeof onSuccess === "function") {
              try {
                await onSuccess();
              } catch (err) {
                console.error("Failed to auto-refresh RPT tables", err);
              }
            }
          }}
          setSuccessModal={setShowSuccessModal}
          setSuccessMessage={setSuccessMessage}
          successMessage={successMessage}
        />
      )}

      {showErrorModal && (
        <ErrorModal
          handleClose={() => setShowErrorModal(false)}
          setErrorModal={setShowErrorModal}
          setErrorMessage={setErrorMessage}
          errorMessage={errorMessage}
        />
      )}
    </>
  );
};

export default AddRPTTransactionModal;
